import { render, staticRenderFns } from "./TableIncidence.vue?vue&type=template&id=31ad5d12&scoped=true"
import script from "./TableIncidence.vue?vue&type=script&lang=js"
export * from "./TableIncidence.vue?vue&type=script&lang=js"
import style0 from "./TableIncidence.vue?vue&type=style&index=0&id=31ad5d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad5d12",
  null
  
)

export default component.exports